import React from "react";
import {getStoresContent} from "../../../utils/utils"

function StoresHeader(props) {

    return (
        <div style={{display:"flex", justifyContent: "space-around"}}>
            <div style={{display:"flex", flexDirection:"column"}}>
                <div className={["blueText", "subtitleSize"].join(" ")} style={{textAlign:"center"}}>
                    Loja de Retirada
                </div>
                <div className={["labelText", "normalMediumSize"].join(" ")} style={{textAlign:"center"}}>
                    {props.storeInfo.rental_store == null ? props.reservation.rental_store == null ? 
                    "Indisponível" : props.reservation.rental_store : 
                    getStoresContent(props.storeInfo, "rental_store")}
                </div>
            </div>
            <div style={{display:"flex", flexDirection:"column"}}>
                <div className={["blueText", "subtitleSize"].join(" ")} style={{textAlign:"center"}}>
                    Loja de Devolução
                </div>
                <div className={["labelText", "normalMediumSize"].join(" ")} style={{textAlign:"center"}}>
                    {props.storeInfo.devolution_store == null ? props.reservation.devolution_store == null ? 
                    "Indisponível" : props.reservation.devolution_store : 
                    getStoresContent(props.storeInfo, "devolution_store")}
                </div>
            </div>
        </div>
    )
}

export default StoresHeader